var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpaceListIcon = function SvgSpaceListIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 132.292 132.292",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.189 -.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1226",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128.977,
    height: 41.658,
    x: 1.847,
    y: 1.485,
    fill: "#e5e5e5",
    stroke: "none",
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.755,
    ry: 3.809
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    stroke: "none",
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.723,
    d: "M5.707 1.485H45.28v41.628H5.64a3.794 3.794 45 01-3.793-3.794V5.346a3.86 3.86 135 013.86-3.861z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.563,
    cy: 22.314,
    fill: "#cbcbcb",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.323,
    rx: 13.892,
    ry: 13.324
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bfbfbf",
    stroke: "none",
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 1.025,
    d: "M49.808 5.694H96.14V11.838000000000001H49.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfcfcf",
    stroke: "none",
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.507,
    d: "M49.808 13.168H70.517V16.535H49.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    stroke: "none",
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 2.082,
    d: "M49.808 18.352H126.487V33.67H49.808z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path1108",
    cx: 52.353,
    cy: 37.827,
    fill: "#cdcdcd",
    stroke: "none",
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.934,
    rx: 2.545,
    ry: 2.441
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "#cdcdcd",
    transform: "translate(7.787)",
    xlinkHref: "#path1108"
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "#cdcdcd",
    transform: "translate(15.574)",
    xlinkHref: "#path1108"
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "#cdcdcd",
    transform: "translate(23.36)",
    xlinkHref: "#path1108"
  })), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    transform: "translate(0 44.45)",
    xlinkHref: "#g1226"
  }), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    transform: "translate(0 88.9)",
    xlinkHref: "#g1226"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpaceListIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/space-list-icon.1dd5d050f964c9a8b7f267b030cc10b4.svg";